import React, { Component } from 'react';
import { Button, Tabs, Modal, Input, message, Badge, DatePicker  } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import client from 'features/userManage/api/client'
import { Loader } from 'semantic-ui-react';
import moment from 'moment-timezone';
import TagComponent from 'common/ui/renderers/agGrid/TagComponent';
import {
  signInGridColumns,
  extraHoursGridColumns,
  signApprovedGridColumns
} from './GridColumnMap';
import './ClockManageDashboard.css';
import _ from 'lodash';
import UpdateClockModal from './UpdateClockModal';
import AddClockModal from './AddClockModal';
import { isAdminRole } from 'common/utils/DomainUtils';

const TabPane = Tabs.TabPane;
class ClockManageDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      status: 'READY',
      extraHoursApplyData: [],
      otherDatas:[],
      queryParams: {
        startDate: moment().add(-31, 'days'),
        endDate:  moment(),
      },
      selectedSignData: null,
      showUpdateClockModal: false,
      showAddClockModal: false,
      signRecords: [],
      approvedSignRecords: [],
      selectedApprovedData: null,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 50,
        width: 130,
        sortable: true,
        filter: true,
        resizable: true
      },
      context: {
        gridComponent: this
      },
      selectedData: null,
      pivotPanelShow: 'always',
      rowGroupPanelShow: 'always',
      sideBar: {
        toolPanels: ['columns', 'filters']
      },
    }
  }


  componentDidMount() {
    this.loadExtraHoursRecords();
  }

  _disableClockRecord = () => { 
    const { selectedSignData } = this.state;

    if (selectedSignData) {
      const { userAccountId, clockDate } = selectedSignData;
      Modal.confirm({
      title: 'Remove Clock Record',
      content: `Are you sure to remove ${selectedSignData.createdBy} ${selectedSignData.clockDate} clock record?`,
      onOk: () => {
        client.disableClockByAdmin({userAccountId, date: clockDate})
        .then(res => {
            message.success('Remove success');
            this.loadSignRecords();
         
        }).catch(err => {console.log(err)});
      },
      okText: 'Yes',
      cancelText: 'No'
    });
  }
}

  /**
   * 处理打卡记录，按用户和日期分组，计算每天工时
   * @param {Array} records - 格式化的打卡记录
   * @returns {Array} 每天的工时记录列表
   */
  _processDailyWorkHours = (records) => {
    const { extraHoursApplyData } = this.state;
    // 按 createdBy 和 clockDate 分组
    const grouped = _.groupBy(records, r => `${r.createdBy}_${r.clockDate}_${r.userAccountId}`);
    const extraHoursApplyMap = extraHoursApplyData.reduce((acc, record) => {
      const key = `${record.createdBy}_${record.date}_${record.userAccountId}`;

      if (!acc.has(key)) {
        acc.set(key, {
          createdBy: record.createdBy,
          date: record.date,
          userAccountId: record.userAccountId,
          totalApplyHours: 0
        });
      }

      if (['PASS', 'PENDING_REMOVE'].includes(record.status)) {
        const current = acc.get(key);
        current.totalApplyHours += record.applyHours || 0;
      }

      return acc;
    }, new Map());
    const result = [];

    _.forEach(grouped, (userDayRecords, key) => {
      const [createdBy, clockDate, userAccountId] = key.split('_');

      // 按 createdOn 时间排序
      const sortedRecords = _.orderBy(userDayRecords, ['dbCreatedOn'], ['asc']);

      // 获取最后一次 Clock In (type 为 SIGN_IN)
      const clockInRecord = sortedRecords.findLast(r => r.type === 'ClockIn');
      // 获取最后一次 Clock Out (type 为 SIGN_OUT)
      const clockOutRecord = _.findLast(sortedRecords, r => r.type === 'ClockOut');

      if (clockInRecord && clockOutRecord) {
        const clockInTime = moment(clockInRecord.createdOn, 'YYYY-MM-DD HH:mm:ss');
        const clockOutTime = moment(clockOutRecord.createdOn, 'YYYY-MM-DD HH:mm:ss');

        // 计算间隔小时数，保留2位小数
        const workHours = parseFloat((clockOutTime.diff(clockInTime, 'hours', true)).toFixed(2));
        const extraHours = extraHoursApplyMap.get(key) ? extraHoursApplyMap.get(key).totalApplyHours : 0
        const exceedHours = workHours - (9 + extraHours);
        result.push({
          type: 'Clock',
          key,
          userAccountId,
          createdBy,
          clockDate,
          clockIn: clockInRecord.createdOn,
          clockOut: clockOutRecord.createdOn,
          workHours,
          // 保留原始记录用于调试
          _originalRecords: sortedRecords,
          approvedHours: extraHoursApplyMap.get(key) ? extraHoursApplyMap.get(key).totalApplyHours : 0,
          exceedHours: exceedHours > 0?_.round(exceedHours, 2):0,
          isExceed: workHours > (9.5 + extraHours)?'Y':'N'
        });
      } else if (clockInRecord || clockOutRecord) {
        // 只有 Clock In，没有 Clock Out
        result.push({
          type: 'Clock',
          key,
          userAccountId,
          createdBy,
          clockDate,
          clockIn: clockInRecord?.createdOn,
          clockOut: clockOutRecord?.createdOn,
          workHours: null,
          _originalRecords: sortedRecords,
          approvedHours: extraHoursApplyMap.get(key) ? extraHoursApplyMap.get(key).totalApplyHours : 0,
          isExceed: 'N'
        });
      }
    });

    return result;
  }

  // 检查是否在请假期间
  loadSignRecords = async () => {
    const { queryParams } = this.state;
    const params = { 
      startDate: queryParams.startDate.format('YYYY-MM-DD'),
      endDate: queryParams.endDate.format('YYYY-MM-DD')
    }
    this.setState({
      status: 'LOADING'
    })
    Promise.all([client.getAllSignRecords(params), client.getAllLeaveRecordAndHoliday(params)])
    .then(([resp, leaveAndHolidays]) => {
      // 原始数据格式化
      const formattedRecords = resp ? resp.map(r => ({
        ...r,
      })) : [];

      const approvedSignRecords = formattedRecords.filter(r => r.remark);

      // 按 createdBy 和 clockDate 分组，计算每个人每天的工时
      const dailyRecords = this._processDailyWorkHours(formattedRecords.filter(r => ['PASS', 'PENDING_REMOVE'].includes(r.status)));

      const { leaveDataList, holidayList } = leaveAndHolidays || {};
      const otherDatas = [];
      if(!_.isEmpty(leaveDataList)) {
        Object.keys(leaveDataList).forEach(key => {
        leaveDataList[key].forEach(item => {
          otherDatas.push({ type: 'Vacation', createdBy: key, key: `Vacation-${key}-${item}`, clockDate: item})
        })
      });
      }
       if(!_.isEmpty(holidayList)) {
        holidayList.forEach(item => {
          otherDatas.push({ type: 'Holiday', key: `Holiday-${item}`, clockDate: item})
        })
      }

      this.setState({
        approvedSignRecords,
        signRecords: dailyRecords,
        otherDatas,
        status: 'READY'
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  loadExtraHoursRecords = () => {
    this.setState({
      status: 'LOADING'
    })
    client.getUserClockApplyRecordList({}).then(resp => {
      this.setState({
        extraHoursApplyData: resp ? resp.map(r => ({
          ...r,
        })) : [],
        status: 'READY',
        selectedData: null
      }, this.loadSignRecords)
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      }, this.loadSignRecords)
    })
  }

  onGridReady = params => {
    this.signGridApi = params.api;
    this.signColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  onExtraGridReady = params => {
    this.extraGridApi = params.api;
    this.extraColumnApi = params.columnApi;

    this.extraGridApi.sizeColumnsToFit();
  };

  onApprovedGridReady = params => {
    this.approvedGridApi = params.api;
    this.approvedColumnApi = params.columnApi;

    this.approvedGridApi.sizeColumnsToFit();
  };

  _createApprovedSignRecordGrid = () => {
    const { status, approvedSignRecords } = this.state;
    const showData = approvedSignRecords 
  ? _.orderBy(
      approvedSignRecords,
      [
        (item) => {
          if (['NEW', 'PENDING_REMOVE'].includes(item.status)) return 0;
          return 1;
        },
        'status',    
        'clockDate'  
      ],
      ['asc', 'asc', 'desc']
    )
  : [];
    const statusCounts = _.countBy(showData, 'status');
    const pendingCount = (statusCounts['NEW'] || 0) + (statusCounts['PENDING_REMOVE'] || 0);
    return (
      <>
        <div style={{ textAlign: 'right' }}>
          <Badge count={pendingCount}><Button onClick={this.loadSignRecords} size='small' type='primary'>Reload</Button></Badge>
          <Button onClick={this._passApproved} size='small' type='primary' style={{ marginLeft: `${pendingCount>0? '12px': '5px'}`}}>Pass</Button>
          <Button onClick={this._rejectedApprovedClick} size='small' type='primary' style={{ marginLeft: '5px' }}>Rejected</Button>
        </div>
        <div className={`ag-theme-balham-dark grid-wrapper`} style={{ height: '90%' }}>
          {!status === 'LOADING' ? (
            <Loader active inverted content="Loading..." />
          ) : (
            <AgGridReact
              // properties
              columnDefs={signApprovedGridColumns}
              defaultColDef={this.state.defaultColDef}
              rowData={showData}
              suppressAggFuncInHeader={true}
              groupDefaultExpanded={-1}
              animateRows={true}
              enableRangeSelection={true}
              pivotPanelShow={this.state.pivotPanelShow}
              rowGroupPanelShow={this.state.rowGroupPanelShow}
              sideBar={this.state.sideBar}
              rowSelection="single"
              onSelectionChanged={this.onApprovedSelectionChanged}
              getRowNodeId={params => params.id}
              onGridReady={this.onApprovedGridReady}
            />
          )}
        </div>
      </>
    )
  }

  getSignContextMenuItems = params => {
    if (params.node == null) return [];
    if(!this._canOpration()) return [];
    if(params.node && params.node.data && params.node.data.type !== 'Clock') return [];
    const menuItems = [
      {
        name: 'Update ClockTime',
        action: () => this._toggleUpdateClockModal(true)
      },
      {
        name: 'Remove Clock',
        action: () => this._disableClockRecord()
      }
    ];

    return menuItems;
  }

  onSignSelectionChanged = () => {
    const selectedRows = this.signGridApi ? this.signGridApi.getSelectedRows() : [];
    if (_.isEmpty(selectedRows)) return;
    this.setState({
      selectedSignData: {
        ...selectedRows[0],
        clockIn: moment(selectedRows[0].clockIn),
        clockOut: selectedRows[0].clockOut?moment(selectedRows[0].clockOut):null,
      }
    });
  };

  _onQueryParamChange = ({name, value}) => { 
    this.setState({
      queryParams: {
        ...this.state.queryParams,
        [name]: value
      }
    })
  }

  _createSignRecordGrid = () => {
    const { status, signRecords, otherDatas, queryParams } = this.state;
    const otherData = _.isEmpty(otherDatas)?[]:otherDatas;
    const signRecordList = _.isEmpty(signRecords)?[]:signRecords;
    const showData = _.orderBy([...otherData, ...signRecordList], ['clockDate'], ['desc']);
    return (
      <>
        <div style={{ textAlign: 'right' }}>
          <DatePicker defaultValue={queryParams.startDate}
                                          format={'YYYY-MM-DD'}
                                          size="small"
                                          onChange={(value) => {
                                              this._onQueryParamChange({ name: 'startDate', value });
                                          }}
                                          style={{ marginRight: '5px' }} />
          <DatePicker defaultValue={queryParams.endDate}
                                          format={'YYYY-MM-DD'}
                                          size="small"
                                          onChange={(value) => {
                                              this._onQueryParamChange({ name: 'endDate', value });
                                          }}
                                          style={{ marginRight: '5px' }} />
          <Button onClick={this.loadSignRecords} size='small' type='primary'>Reload</Button>
          {this._canOpration() 
            && <Button style={{marginLeft: '5px'}} onClick={() => this._toggleAddClockModal(true)} size='small' type='primary'>Add Clock</Button>}
          
        </div>
        <div className={`ag-theme-balham-dark grid-wrapper`} style={{ height: '90%' }}>
          {!status === 'LOADING' ? (
            <Loader active inverted content="Loading..." />
          ) : (
            <AgGridReact
              // properties
              columnDefs={signInGridColumns}
              defaultColDef={this.state.defaultColDef}
              rowData={showData}
              suppressAggFuncInHeader={true}
              groupDefaultExpanded={-1}
              animateRows={true}
              enableRangeSelection={true}
              pivotPanelShow={this.state.pivotPanelShow}
              rowGroupPanelShow={this.state.rowGroupPanelShow}
              sideBar={this.state.sideBar}
              rowSelection="single"
              getRowNodeId={params => params.key}
              frameworkComponents={{
                tagComponent: TagComponent
              }}
              onGridReady={this.onGridReady}
              getContextMenuItems={this.getSignContextMenuItems}
              onSelectionChanged={this.onSignSelectionChanged}
            />
          )}
        </div>
      </>
    )
  }

  onSelectionChanged = () => {
    const selectedRows = this.extraGridApi.getSelectedRows();
    if (selectedRows) {
      this.setState({
        selectedData: selectedRows[0]
      });
    }
  };

  onApprovedSelectionChanged = () => {
    const selectedRows = this.approvedGridApi.getSelectedRows();
    if (selectedRows) {
      this.setState({
        selectedApprovedData: selectedRows[0]
      });
    }
  };

  _pass = () => {
    const { selectedData } = this.state;
    if (selectedData) {
      if (selectedData.status !== 'NEW') {
        Modal.info({
          title: 'Check',
          content: `Already ${selectedData.status}.`,
        })
        return;
      }
      client.verifyClockHours({ id: selectedData.id, status: 'PASS' }).then(() => {
        message.info("Success pass.")
        this.loadExtraHoursRecords();
      });
    }
  }

  _onFeedbackChage = (e) => {
    const { selectedData } = this.state;
    this.setState({
      selectedData: {
        ...selectedData,
        feedback: e.target.value
      }
    });
  }

  _rejectedClick = () => {
    const { selectedData } = this.state;
    if (!selectedData) return;
    if (selectedData.status !== 'NEW') {
      Modal.info({
        title: 'Check',
        content: `Already ${selectedData.status}.`,
      })
      return;
    }
    Modal.confirm({
      title: 'Rejected',
      content: <Input placeholder='Please input feedback' onChange={this._onFeedbackChage} />,
      onOk: () => {
        this._rejected();
      }
    })
  }

  _rejected = () => {
    const { selectedData } = this.state;
    if (selectedData && !_.isEmpty(selectedData.feedback)) {
      client.verifyClockHours({ id: selectedData.id, feedback: selectedData.feedback, status: 'REJECTED' }).then(() => {
        message.info("Success rejected.")
        this.loadExtraHoursRecords();
      });
    } else {
      Modal.info({
        title: 'Check',
        content: `Feedback is required`,
      })
    }
  }

  _passApproved = () => {
    const { selectedApprovedData } = this.state;
    if (selectedApprovedData) {
      if (!['NEW', 'PENDING_REMOVE'].includes(selectedApprovedData.status)) {
        Modal.info({
          title: 'Check',
          content: `Already ${selectedApprovedData.status}.`,
        })
        return;
      }
      client.verifySign({ id: selectedApprovedData.id, status: selectedApprovedData.status==='NEW'?'PASS':'REMOVE' }).then(() => {
        message.info("Success pass.")
        this.loadSignRecords();
      });
    }
  }

  _onFeedbackApprovedChage = (e) => {
    const { selectedApprovedData } = this.state;
    this.setState({
      selectedApprovedData: {
        ...selectedApprovedData,
        feedback: e.target.value
      }
    });
  }

  _rejectedApprovedClick = () => {
    const { selectedApprovedData } = this.state;
    if (!selectedApprovedData) return;
    if (!['NEW', 'PENDING_REMOVE'].includes(selectedApprovedData.status)) {
      Modal.info({
        title: 'Check',
        content: `Already ${selectedApprovedData.status}.`,
      })
      return;
    }
    Modal.confirm({
      title: 'Rejected',
      content: <Input placeholder='Please input feedback' onChange={this._onFeedbackApprovedChage} />,
      onOk: () => {
        this._rejectedApproved();
      }
    })
  }

  _rejectedApproved = () => {
    const { selectedApprovedData } = this.state;
    if (selectedApprovedData && !_.isEmpty(selectedApprovedData.feedback)) {
      client.verifySign({ id: selectedApprovedData.id, 
        feedback: selectedApprovedData.feedback, 
        status: 'REJECTED' }).then(() => {
        message.info("Success rejected.")
        this.loadSignRecords();
      });
    } else {
      Modal.info({
        title: 'Check',
        content: `Feedback is required`,
      })
    }
  }

  _createExtraAgGrid = () => {
    const { status, extraHoursApplyData } = this.state;
    const showData = extraHoursApplyData ? _.orderBy(extraHoursApplyData, ['status', 'createdOn'], ['asc', 'desc']) : [];
    const pendingCount = _.countBy(showData, 'status')['NEW'] || 0;
    return (
      <>
        <div style={{ textAlign: 'right' }}>
          <Badge count={pendingCount} ><Button onClick={this.loadExtraHoursRecords} size='small' type='primary'>Reload</Button></Badge>
          <Button onClick={this._pass} size='small' type='primary' style={{ marginLeft: `${pendingCount>0? '12px': '5px'}`}}>Pass</Button>
          <Button onClick={this._rejectedClick} size='small' type='primary' style={{ marginLeft: '5px' }}>Rejected</Button>
        </div>

        <div className={`ag-theme-balham-dark grid-wrapper`} style={{ height: '90%' }}>
          {!status === 'LOADING' ? (
            <Loader active inverted content="Loading..." />
          ) : (
            <AgGridReact
              // properties
              columnDefs={extraHoursGridColumns}
              defaultColDef={this.state.defaultColDef}
              rowData={showData}
              suppressAggFuncInHeader={true}
              animateRows={true}
              enableRangeSelection={true}
              groupDefaultExpanded={-1}
              pivotPanelShow={this.state.pivotPanelShow}
              rowGroupPanelShow={this.state.rowGroupPanelShow}
              sideBar={this.state.sideBar}
              rowSelection="single"
              frameworkComponents={{
                tagComponent: TagComponent
              }}
              onSelectionChanged={this.onSelectionChanged}
              getRowNodeId={params => params.id}
              onGridReady={this.onExtraGridReady}
            />
          )}
        </div>
      </>
    )
  }

  _submitUpdateClock = (records) => {
    if(!_.isEmpty(records)) {
      client.signList(records).then(() => {
        message.info("Update Clock Successfully.")
        this._toggleUpdateClockModal(false);
        this.loadSignRecords();
      });
    }
  }

  _submitAddClock = (records) => {
    if(!_.isEmpty(records)) {
      client.signList(records).then(() => {
        message.info("Add Clock Successfully.")
        this._toggleAddClockModal(false);
        this.loadSignRecords();
      });
    }
  }

  _toggleUpdateClockModal = (op) => {
    this.setState({
      showUpdateClockModal: op,
    });
  }

   _toggleAddClockModal = (op) => {
    this.setState({
      showAddClockModal: op,
    });
  }

  _createUpdateClockModal = () => {
    const { showUpdateClockModal, selectedSignData } = this.state;
    return (showUpdateClockModal &&
      <UpdateClockModal 
        data={selectedSignData}
        closeModal={() => {this._toggleUpdateClockModal(false)}}
        submitData={this._submitUpdateClock}
      />
    );
  }

   _createAddClockModal = () => {
    const { showAddClockModal } = this.state;
    return (showAddClockModal &&
      <AddClockModal 
        closeModal={() => {this._toggleAddClockModal(false)}}
        submitData={this._submitAddClock}
      />
    );
  }

  _canOpration = () => {
    const { user } = this.props;
    const role = user? user.role : ''
    const englishName = user? user.englishName : ''
    return isAdminRole(role) || ['ryu.nakatani'].includes(englishName);
  }

  render() {
    return (
      <div className="clockMangerDashboardWrapper">
        <Tabs
          tabPosition={'top'}
        >
         {this._canOpration() && <TabPane tab="Extra Hours" key="2">
            {this._createExtraAgGrid()}
          </TabPane>}
          {this._canOpration() && <TabPane tab="Approval Clock" key="3">
            {this._createApprovedSignRecordGrid()}
          </TabPane>}
          <TabPane tab="Clock Records" key="1">
            {this._createSignRecordGrid()}
          </TabPane>

        </Tabs>
        {this._createUpdateClockModal()}
        {this._createAddClockModal()}
      </div>
    );
  }
}

export default ClockManageDashboard;
